import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
export default function TryACall() {
  const navigate = useNavigate();
  return (
    <>
      <div className='try-a-call'>
        <p className='head'>
          What no one tells you about feeding!
        </p>
        <p className='content'>
          Feeding is more than a routine—it’s full of surprises and silent struggles no one talks about.
        </p>
        <div className='btn-div' style={{ height: '3rem', overflowX: 'visible' }}>
          <button 
          className='bubble-btn btn text-center' 
          style={{ paddingInline: '2rem', width: '30%'}}
          onClick={()=> navigate('/collection/all')}
          >
          {"Shop Now"}
        </button></div>
      </div>
    </>
  )
}
